import {
  fetchClient
} from "./chunk-AQVZKKZU.mjs";
import {
  generateRecaptchaToken
} from "./chunk-5GTK3RJJ.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/auth/refreshTokens.ts
import { Exception } from "@wbk/logger";
var refreshTokens = (refresh_token) => __async(void 0, null, function* () {
  var _a, _b, _c, _d;
  try {
    const captcha = yield generateRecaptchaToken("refetch_token");
    const data = yield fetchClient({
      url: "/refresh_token",
      baseUrl: (_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.authApi,
      options: {
        method: "POST",
        body: JSON.stringify({
          refresh_token,
          captcha,
          app_source: (_d = (_c = ApiConfig.config) == null ? void 0 : _c.wbk) == null ? void 0 : _d.appSource
        })
      }
    });
    return data;
  } catch (error) {
    throw new Exception({ error, name: "refreshTokensException" });
  }
});

export {
  refreshTokens
};
//# sourceMappingURL=chunk-HHLL3SNP.mjs.map